import { KULEWEBVIEW } from '@/config/constant'
import TGASDK from '@/config/TGASDK'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ShareChannel: React.FC<PropType> = ({ onFinish }) => {
  const { t } = useTranslation('share')
  const { params } = useStatePopup(PopupSelector.sharePopup)

  let { channels = [] } = TGASDK.context.appConfig.feature.share

  // 非 KULEWEBVIEW 环境下，过滤掉 inApp
  if (!KULEWEBVIEW) {
    channels = channels.filter(item => item.code !== 'inApp')
  }

  const { type, icon, text, url } = params!

  const getShareLink = (channel: string) => {
    const encodedUrl = encodeURIComponent(url)
    const encodedText = encodeURIComponent(text)

    const shareLinks: Record<string, string> = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      whatsApp: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
      linkedIn: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedText}`,
      reddit: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedText}`,
      telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
      email: `mailto:?subject=${encodedText}&body=${encodedUrl}`,
      line: `https://social-plugins.line.me/lineit/share?url=${encodedUrl}`,
      pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedText}`
    }

    return shareLinks[channel]
  }

  const shareInApp = async () => {
    const res = await window.Bridge.share.shareInside({
      url,
      title: text,
      type: type!,
      iconUrl: icon!
    })

    if (res === null) {
      return true
    } else {
      return false
    }
  }

  const shareOutApp = (code: string) => {
    window.open(getShareLink(code))
  }

  const handleClick = async (code: string) => {
    if (code !== 'inApp') {
      shareOutApp(code)
      onFinish && onFinish()
      return
    }

    const res = await shareInApp()
    if (res) {
      onFinish && onFinish()
    }
  }

  if (channels.length === 0) {
    return null
  }

  return (
    <div className="grid grid-cols-4 gap-2">
      {channels.map(item => (
        <button
          key={item.code}
          className="flex flex-col items-center justify-center gap-1"
          onClick={() => handleClick(item.code)}
        >
          <img
            src={
              item.code === 'inApp' ? TGASDK.context.appConfig.appIcon : require(`@/asset/svg/share/${item.code}.svg`)
            }
            alt={item.code}
            className="h-14 w-14"
          />
          <span className="font-semibold">{t(`channel.${item.code}`)}</span>
        </button>
      ))}
    </div>
  )
}

interface PropType {
  onFinish?: () => void
}

export default ShareChannel
